import { FolderDefinition } from './types';

/**
 * Базовые константы модуля почты
 */
export const MAIL_API_BASE = 'https://tbl.zerdegroup.kz/api/mail';
export const CARBONIO_WEB_URL = 'https://mail.zerdegroup.kz/';

export const MAIL_FOLDERS: FolderDefinition[] = [
  {
    key: 'inbox',
    label: 'Входящие',
    zimbraName: 'Inbox',
    iconName: 'Inbox'
  },
  {
    key: 'sent',
    label: 'Отправленные',
    zimbraName: 'Sent',
    iconName: 'Send'
  },
  {
    key: 'drafts',
    label: 'Черновики',
    zimbraName: 'Drafts',
    iconName: 'Drafts'
  },
  {
    key: 'trash',
    label: 'Корзина',
    zimbraName: 'Trash',
    iconName: 'Delete'
  },
  {
    key: 'junk',
    label: 'Спам',
    zimbraName: 'Junk',
    iconName: 'Report'
  }
];

export const MAIL_COLORS = {
  primary: '#1570ef',
  primaryHover: '#175cd3',
  primaryLight: '#eff8ff',
  primaryBorder: '#b2ddff',
  unreadDot: '#2563eb',
  unreadBg: '#f8fafc',
  borderLight: '#e2e8f0',
  textPrimary: '#0f172a',
  textSecondary: '#475569',
  textMuted: '#94a3b8',
  cardBg: '#ffffff',
  sidebarBg: '#f8fafc',
  hoverBg: 'rgba(241, 245, 249, 0.7)',
  selectedBg: '#f1f5f9',
  danger: '#ef4444'
};
